import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
type ViewState = "question" | "matrix" | "stepCompleted" | "summary";


@Injectable({ providedIn: 'root' })
export class SharedStateService {
  private currentCatSubject = new BehaviorSubject<number>(0);
  currentCat$ = this.currentCatSubject.asObservable();

  setCurrentCategory(cat: number) {
    this.currentCatSubject.next(cat);
  }
  private highlightCategorySubject = new BehaviorSubject<number>(0);
  highlightCategory$ = this.highlightCategorySubject.asObservable();

  setHighlightCategory(cat: number) {
    this.highlightCategorySubject.next(cat);
  }
  private viewStateSubject = new BehaviorSubject<ViewState>('question');
  viewState$ = this.viewStateSubject.asObservable();

  setViewState(state: ViewState) {
    this.viewStateSubject.next(state);
  }
  isPreviewMode = false;
}
